import { useEffect, useState } from 'react';
import { CONSENT_CHANGE_EVENT, getConsentPreferences } from '../utils/consent';

const useConsentPreferences = () => {
  const [preferences, setPreferences] = useState(getConsentPreferences);

  useEffect(() => {
    const handleConsentChange = (event) => {
      setPreferences(event.detail || getConsentPreferences());
    };
    window.addEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
    const refresh = () => setPreferences(getConsentPreferences());
    window.addEventListener('storage', refresh);
    window.addEventListener('lvm:notice-change', refresh);
    return () => {
      window.removeEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
      window.removeEventListener('storage', refresh);
      window.removeEventListener('lvm:notice-change', refresh);
    };
  }, []);

  return preferences;
};

export default useConsentPreferences;
